import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { ToolHeader } from '@/components/tool';
import { useContext } from 'react';
import { ToolsContext } from '@my-helpers/common';
import { useTheme, Grid } from '@mui/material';
import { ArrowBack, Code } from '@mui/icons-material';
import { FunctionContainer } from '@/components/tool/Function';
import { useNavigate } from 'react-router-dom';
import { Notification } from '@/components/Notification';

const ToolView: React.FC = () => {
    const context = useContext(ToolsContext);
    if (!context) {
        throw new Error('ToolsContext not found');
    }
    const { view, command } = context;
    const { isLoading, error, currentTool } = view;
    const { toggleUserToolStatus, clearError } = command;
    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <Box padding={theme.spacing(3)}>
            <ToolHeader
                isLoading={isLoading}
                currentTool={currentTool}
                toggleUserToolStatus={toggleUserToolStatus}
            />
            <Paper sx={{
                p: 2,
                mb: 2,
                borderRadius: 2,
                boxShadow: 2,
                backgroundColor: '#f8fafc',
            }}>
                {
                    currentTool ?
                        currentTool.functions && currentTool.functions.length > 0 ?
                            <Grid container spacing={2}>
                                <Grid 
                                    size={2} 
                                    display="flex" 
                                    flexDirection="row" 
                                    gap={2}>
                                    <Typography
                                        sx={{
                                            fontWeight: 400,
                                            fontSize: '1.2rem',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'flex-end',
                                            alignItems: 'center',
                                            gap: 1
                                        }}>
                                        functions
                                    </Typography>
                                </Grid>
                                <Grid 
                                    size={10} 
                                    display="flex" 
                                    flexDirection="row" 
                                    gap={2}>
                                    <Typography
                                        sx={{
                                            fontWeight: 400,
                                            fontSize: '0.9rem',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'flex-end',
                                            alignItems: 'center',
                                            gap: 1
                                        }}>
                                        parameters
                                    </Typography>
                                </Grid>
                                {
                                    currentTool.functions.map((func, funcIndex) => (
                                        <FunctionContainer func={func} funcIndex={funcIndex} />
                                    ))
                                }
                            </Grid> :
                            <Box sx={{ textAlign: 'center', p: 3 }}>
                                <Code sx={{
                                    fontSize: 48,
                                    color: 'text.disabled',
                                    mb: 2
                                }} />
                                <Typography variant="h6" color="text.secondary">
                                    No functions defined for this tool
                                </Typography>
                            </Box> :
                        <Box sx={{ p: 3 }}>
                            <Typography variant="h6" color="error">
                                Tool not found
                            </Typography>
                            <Button
                                startIcon={<ArrowBack />}
                                onClick={() => navigate('/tools')}
                                sx={{ mt: 2 }}>
                                Back to Tools
                            </Button>
                        </Box>
                }
            </Paper>
            <Notification
                isLoading={isLoading}
                error={error}
                clearError={clearError}
                delay={300}
                autoHideDuration={1200}
            />
        </Box>
    );
};

export default ToolView;